module.exports = __webpack_public_path__ + "static/media/9.2.ed81b176.png";